<template>
  <div class="base">
    <!-- S 内容区 左 -->
    <div class="base__info flex h-[306px] mb-2.5">
      <div class="relative flex-1 flex-shrink-0">
        <el-image class="w-full h-full" v-if="!!data.cover" :src="data.cover" fit="cover">
          <div slot="error" class="image-slot">
            <img src="@/assets/img/company/cruise-placeholder.png" />
            <span>加载失败</span>
          </div>
          <div slot="placeholder" class="image-slot">
            <img src="@/assets/img/company/cruise-placeholder.png" />
            <span>加载中</span>
          </div>
        </el-image>
        <el-image class="w-full h-full" v-else src="@/assets/img/company/cruise-placeholder1.png" fit="cover">
        </el-image>
        <div class="minimap absolute">
          <ul class="flex items-center absolute bottom-[20px] right_35">
            <li class="cursor-pointer relative w-[66px] h-[66px] border border-[rgba(255, 255, 255, 0.5)] mr-[10px]"
              v-for="image in images" :key="image.image" @click="onJumpLink(image.name)">
              <el-image class="w-full h-full" :src="image.image" fit="cover"></el-image>
              <div
                class="minimap__item absolute z-1 left-0 bottom-0 w-full h-[25px] flex items-center justify-center text-[#fff] text-xs font-600">
                {{ image.name }}
              </div>
            </li>
            <li class="cursor-pointer ml-[10px] text-[#fff] text-[13px] text-center font-600 leading-4"
              v-if="images.length">
              <nuxt-link :to="`/company/cruise/gallery?cruiseid=${$route.params.cruiseId}`" target="_blank">
                <div class="relative">
                  查看全部
                  <i class="icon_all_arrow ficon ficon-a-Vector130"></i>
                </div>
                <p>({{ images_num }})</p>
              </nuxt-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="w-120 ml-2.5 bg-white rounded-[2px] py-[22px] pl-5 pr-4">
        <div class="flex items-start mb-3">
          <el-image :src="data.logo" fit="contain" :style="{width:'75px',height:'26px'}" class="logo" v-if="data.logo"/>
          <div> 
            <h2 class="text-[28px] font-medium text-black leading-10 mb-0.5">{{ data.name }}</h2>
            <p class="text-[13px] text-[#B6B6B6]">{{ data.en_name }}</p>
          </div>
        </div>
        <div class="text-block text-sm mb-3" v-if="data.former_name && data.former_name.length">曾用名：{{ data.former_name.join(',') }}</div>
        <ul class="list-none flex flex-wrap -mr-4.5 ">
          <li class="c-tag"  v-if="rank.tonnage !== '0'"><nuxt-link to="/company/new-ranking-basis?activeType=tonnage" target="_blank">吨位 NO.{{ rank.tonnage }} <i class="ficon-a-Vector130 ficon text-[12px]"></i></nuxt-link></li>
          <li class="c-tag" v-if="rank.service_ratio !== '0'"><nuxt-link to="/company/new-ranking-basis?activeType=service_ratio" target="_blank">服务比 NO.{{ rank.service_ratio }} <i class="ficon-a-Vector130 ficon text-[12px]"></i></nuxt-link></li>
          <li class="c-tag" v-if="rank.passenger_capacity !== '0'"><nuxt-link to="/company/new-ranking-basis?activeType=passenger_capacity" target="_blank">载客 NO.{{ rank.passenger_capacity }} <i class="ficon-a-Vector130 ficon text-[12px]"></i></nuxt-link></li>
          <li class="c-tag" v-if="rank.first_flight_time !== '0'"><nuxt-link to="/company/new-ranking-basis?activeType=first_flight_time" target="_blank">新船 NO.{{ rank.first_flight_time }} <i class="ficon-a-Vector130 ficon text-[12px]"></i></nuxt-link></li>
        </ul>
        <ul class="list-none flex flex-wrap text-black text-[15px] -mb-3">
          <li class="w-full mb-3">
            公司：{{ data.company_name }}
          </li>
          <li class="w-1/2 mb-3">
            旗帜：{{ data.country }}
          </li>
          <li class="w-1/2 mb-3">
            类型：{{ data.class }}
          </li>
          <li class="w-1/2 mb-3">
            首航时间：{{ data.first_flight_time }}
          </li>
          <li class="w-1/2 mb-3">
            级别：{{ data.category }}
          </li>
          <li class="w-1/2 mb-3">
            翻新时间：{{ data.renovation_time }}
          </li>
          <li class="w-1/2 mb-3">
            船龄：{{ data.cruise_year }}
          </li>
        </ul>
      </div>
    </div>
    <div class="bg-white rounded-[2px] pt-[15px] px-5 pb-[19px]">
      <h3 class="card-title">基础数据</h3>
      <ul class="flex flex-wrap list-none text-black text-[15px] pl-2.5 info-ul">
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-[20px] mr-2 ficon ficon-dunwei2"></i>
            <div>吨位：</div>
          </div>
          <div class="pr-5">{{ data.tonnage }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-jiaban1"></i>
            <div>甲板楼层：</div>
          </div>
          <div class="pr-5">{{ data.deck_floor }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-fuwubi2"></i>
            <div >服务比：</div>
          </div>
          <div class="pr-5">{{ data.service_ratio }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-[15px] mr-2 ficon ficon-changdu2"></i>
            <div>长度：</div>
          </div>
          <div class="pr-5">{{ data.length }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-xingzhuangjiehe4"></i>
            <div>带船舱甲板数：</div>
          </div>
          <div class="pr-5">{{ data.cabin_deck_num }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-xingzhuangjiehe5"></i>
            <div>乘客空间比：</div>
          </div>
          <div class="pr-5">{{ data.space_ratio }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-kuandu1"></i>
            <div>宽度：</div>
          </div>
          <div class="pr-5">{{ data.width }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-xingzhuang1"></i>
            <div>舱房数量：</div>
          </div>
          <div class="pr-5">{{ data.cabins_num }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-chengkekongjianbi"></i>
            <div>冰级：</div>
          </div>
          <div class="pr-5">{{ data.ice_class }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-[14px] mr-2 ficon ficon-a-kuandu1"></i>
            <div>高度：</div>
          </div>
          <div class="pr-5">{{ data.height }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-zaikerenshu"></i>
            <div>载客人数：</div>
          </div>
          <div class="pr-5">{{ data.passenger_capacity }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-chongfengting"></i>
            <div>冲锋艇：</div>
          </div>
          <div class="pr-5">{{ data.assault_boat }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-center whitespace-nowrap">
            <i class="text-lg mr-[11px] ficon ficon-chuansu1"></i>
            <div>船速：</div>
          </div>
          <div class="pr-5">{{ data.sailing_speed }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-center whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-xingzhuang-1"></i>
            <div>工作人员：</div>
          </div>
          <div class="pr-5">{{ data.personnel }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-center whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-jiushengting"></i>
            <div>救生艇：</div>
          </div>
          <div class="pr-5">{{ data.lifeboat }}</div>
        </li>
      </ul>
      <ul class="extra-info" v-if="showMore">
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-lujing2"></i>
            <div>造船厂：</div>
          </div>
          <div class="pr-5">{{ data.shipyard }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-1 ficon ficon-lujing-31"></i>
            <div>发动机（动力）：</div>
          </div>
          <div class="pr-5">{{ data.engine_power }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-a-lianji91"></i>
            <div>推动力：</div>
          </div>
          <div class="pr-5">{{ data.impetus }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-xingzhuangjiehe7"></i>
            <div>经营者：</div>
          </div>
          <div class="pr-5">{{ data.manipulator }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-[20px] mr-2 ficon ficon-lujing-21"></i>
            <div>造价：</div>
          </div>
          <div class="pr-5">{{ data.cost }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-lujing-41"></i>
            <div>受洗：</div>
          </div>
          <div class="pr-5">{{ data.baptized }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-lg mr-2 ficon ficon-a-lianji51"></i>
            <div>所有者：</div>
          </div>
          <div class="pr-5">{{ data.owner }}</div>
        </li>
        <li class="w-1/3 mb-3 flex items-baseline">
          <div class="flex items-baseline whitespace-nowrap">
            <i class="text-[20px] mr-2 ficon ficon-a-lianji81"></i>
            <div>姐妹船：</div>
          </div>
          <div class="pr-5">{{ data.sister_ship }}</div>
        </li>
      </ul>
      <el-button class="pl-2.5 py-0" type="text" @click="showMore = !showMore">
        <template v-if="!showMore">
          查看更多数据信息<i class="ficon ficon-arrow-bottom"></i>
        </template>
        <template v-else>收起<i class="ficon ficon-arrow-top"></i></template>
      </el-button>

    </div>
  </div>
</template>

<script>
// import SwiperBanner from "@/components/SwiperBanner";
import { TABS } from "~/constants/galleryEnum";
export default {
  name: "DetailBase",
  components: {
    // SwiperBanner
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    images_num: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default: () => [],
    },
    rank: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      navCode: "base",
      showMore: false,
    };
  },
  methods: {
    changeNav(code) {
      this.navCode = code;
    },
    onJumpLink(title) {
      let { name } = TABS.find((item) => item.title === title);
      this.$router.push({
        path: `/company/cruise/gallery?cruiseid=${this.$route.params.cruiseId}#${name}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.minimap {
  position: absolute;
  width: 100%;
  height: 251px;
  left: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 38.02%, rgba(0, 0, 0, 0.54) 100%);
  border-radius: 2px 0px 0px 2px;
  z-index: 1;
}
.minimap__item {
  background-color: rgba(0, 0, 0, 0.6);
}
.minimap .icon_all_arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 100%;
  margin-left: 8px;
}
.config__bg {
  filter: blur(34px);
  background: url("@/assets/img/company/cruise-placeholder1.png") no-repeat center center;
  background-size: 100% 100%;
}
.config__cover {
  background-color: rgba(43, 52, 62, 0.75);
  border-radius: 2px;
}
.config .nav__item {
  color: rgba(210, 220, 235, 0.8);
  transition: 0.2s all ease;
  background: linear-gradient(360deg, #333f4f 0%, #6c798b 100%);
}
.config .nav--active {
  color: #fff;
  background: transparent;
}
.config .tag__label {
  color: rgba(210, 220, 235, 0.8);
}
.config .configure__info {
  font-size: 14px;
}
.config .configure__info .ficon::before {
  font-size: 18px;
}
.image-slot {
  background: url("@/assets/img/company/cruise-placeholder1.png") no-repeat center center;
  background-size: 100% 100%;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: 500;
  height: 436px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
}
.image-slot img {
  height: 87px;
  width: 156px;
}
.image-slot span {
  margin-top: 14px;
  text-align: center;
  width: 100%;
}
.right_35 {
  right: 35px;
}
.logo {
  box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
  margin-right: 14px;
}
.c-tag {
  border-radius: 4px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  margin-right: 0.5rem;
  margin-bottom: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
  height: 25px;
  background: #EBF1FA;
}
.card-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-weight: 500;
  margin-bottom: 1rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.card-title::before {
  display: block;
  content: '';
  width: 5px;
  border-radius: 30px;
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  height: 1.25rem;
  margin-right: 0.5rem;
}
.info-ul .ficon {
  color: #6F757B;
}
.info-ul li {
  line-height: 1.5;
}
.extra-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  list-style-type: none;
  margin-bottom: 1rem;
  padding-top: 18px;
  padding-left: 0.625rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  font-size: 15px;
  border-top: 1px dashed #CACACA;
  line-height: 1.7;
}
.extra-info li {
  line-height: 1.5;
}
.extra-info .ficon {
  color: #6F757B;
}
</style>
